import React from 'react';
import { Button } from 'reactstrap';
import { PauseBillingDetailsFooter } from '../../../shared';
import { useNavigationActions } from '../../../../context';

/**
 * Component that displays the confirmation message after billing has been successfully paused
 * Shows pause details and encourages continued engagement
 */
const BillingPauseConfirmation = () => {
  // Get actions from context
  const { returnToWLC } = useNavigationActions();

  return (
    <div className="billing-pause-confirmation-content">
      <div className="mb-4">
        <h5 className="mb-3">Your billing is paused.</h5>
        <p className="mb-3">
          Your billing period is paused for 30 days, and your WHOLE Life Club membership remains fully active during
          that time.
        </p>
        <p className="mb-3">
          Your next billing date will automatically shift forward to reflect your pause, and we'll send you a reminder
          before your billing period resumes.
        </p>
        <p className="mb-3">
          This billing pause gives you a little breathing room to reset, refocus, or rediscover how The Club can fit
          into your routine.
        </p>
        <p className="mb-4">
          You can jump back in anytime. We'll be here with your favorite recipes, lessons, and community when you're
          ready.
        </p>

        <div className="mb-4 text-center">
          <Button color="primary" size="lg" onClick={returnToWLC} className="mb-3">
            Return to WHOLE Life Club
          </Button>
        </div>

        <p className="mb-4 text-muted">
          Even a small step (a single recipe, a 3-minute action of the week video) can help you make progress towards a
          healthier life.
        </p>

        <PauseBillingDetailsFooter className="pause-confirmation-details" />
      </div>
    </div>
  );
};

export default BillingPauseConfirmation;
